<div class="relative w-full" (mouseenter)="pause()" (mouseleave)="play()">
  <div class="overflow-hidden rounded-md bg-neutral-50 dark:bg-neutral-900">
    <div class="whitespace-nowrap transition-transform duration-500"
         [style.transform]="'translateX(-' + index * 100 + '%)'
         "
    >
      @for (img of images; track img; let i = $index) {
        <img [ngSrc]="img" height="320" width="640" priority
             (click)="openFullscreen(i)"
             alt="Imagem do produto"
             class="inline-block w-full h-80 object-contain cursor-zoom-in" />
      }
    </div>
  </div>

  <button type="button" (click)="prev()"
          class="absolute inset-y-0 left-0 my-auto ml-2 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-white hover:bg-black/60">‹</button>
  <button type="button" (click)="next()"
          class="absolute inset-y-0 right-0 my-auto mr-2 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-white hover:bg-black/60">›</button>

  <div class="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-2">
    @for (img of images; track img; let i = $index) {
      <button type="button" (click)="goTo(i)"
              class="w-2.5 h-2.5 rounded-full"
              [ngClass]="i === index ? 'bg-white' : 'bg-white/50'">
      </button>
    }
  </div>
</div>

<!-- Fullscreen modal -->
@if (fullscreenOpen) {
  <app-modal [open]="fullscreenOpen">
    <div class="relative">
      <img [ngSrc]="images[index]" height="800" width="1200" alt="Imagem ampliada" class="w-full max-h-[50vh] object-contain" />
      <div class="absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-between px-2">
        <button type="button" (click)="prev()" class="w-10 h-10 rounded-full bg-black/40 text-white">‹</button>
        <button type="button" (click)="next()" class="w-10 h-10 rounded-full bg-black/40 text-white">›</button>
      </div>
      <div class="mt-3 flex flex-wrap gap-2 justify-center">
        @for (img of images; track img; let i = $index) {
          <img [ngSrc]="img" height="60" width="90" alt="thumb"
               (click)="goTo(i)"
               class="h-14 w-20 object-cover border rounded cursor-pointer"
               priority
               [ngClass]="i === index ? 'ring-2 ring-blue-500' : ''"
          />
        }
      </div>
      <div class="mt-4 text-center">
        <button type="button" class="px-3 py-1 rounded bg-neutral-200 text-black dark:bg-neutral-800 dark:text-white" (click)="closeFullscreen()">Fechar</button>
      </div>
    </div>
  </app-modal>
}
